import {
  createRouteMask,
  createRouter,
  ErrorComponent,
  isRedirect,
} from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { routeTree } from 'src/routeTree.gen';
import { useEffect } from 'react';
import PageLoader from 'src/components/ui/PageLoader';

/** Shown while a lazy route chunk is loading. */
const PendingComponent = () => <PageLoader />;

const courseModalToCourseMask = createRouteMask({
  routeTree,
  from: '/courses/$courseId/short-view',
  to: '/courses/$courseId/details',
});

const ErrorHandler = ({ error }: { error: any }) => {
  useEffect(() => {
    if (error && !isRedirect(error)) Sentry.captureException(error);
  }, [error]);

  return <ErrorComponent error={error} />;
};

const router = createRouter({
  routeTree,
  unmaskOnReload: true,
  routeMasks: [courseModalToCourseMask],
  defaultErrorComponent: ErrorHandler,
  defaultPreload: 'intent',
  defaultPendingComponent: PendingComponent,
  // wait before showing pending UI to avoid flashes on short transitions
  defaultPendingMs: 450,
  // keep pending UI visible briefly once shown to avoid flicker
  defaultPendingMinMs: 350,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default router;
